import styles from "./AboutMe.module.css";

import PostModel from "../../components/PostModel";
import fotoCapa from "../../assets/about_me_head.png";
import aboutMeFoto from "../../assets/about_me_foto-2.jpeg";

export default function AboutMe() {
    return (
        <PostModel
            fotoCapa={fotoCapa}
            title="Trajetória"
        >
            <h3 className={styles.subTitle}>
                Olá, eu sou Fábio Ramos!
            </h3>

            <img
                src={aboutMeFoto}
                alt="Foto"
                className={styles.aboutMeFoto}
            />

            <p className={styles.paragraph}>
                Atualmente atuo como Líder de Desenvolvimento JAVA, me sinto realizado com minha trajetória, pois o caminho foi longo e desafiador.
            </p>
            <p className={styles.paragraph}>
                Iniciei na área de tecnologia com 16 anos de idade, naquela época eu tinha acabado de terminar um curso de Montagem de Manutenção de Computadores. Como sempre me senti confiante, principalmente por ter facilidade em aprender sozinho, aceitei o desafio de ser instrutor de Hardware e Informática. Foi nesta época que aprendi a gostar de compartilhar conhecimento com outras pessoas, aquilo me fazia sentir bem, principalmente quando via o interesse nos olhos dos alunos.
            </p>
            <p className={styles.paragraph}>
                Depois de um tempo como instrutor, resolvi aceitar outro desafio, arrendar a escola de informática onde eu lecionava. Esta fase me fez entender como empreender era dificil, não tinha maturidade suficiente para tocar um negócio e acabei fechando a escola. Mas continuei por um bom tempo empreendendo, mas como Técnico em Informática, fazendo manutenção de computares, impressoras, enchendo cartuchos e montando redes.
            </p>
            <p className={styles.paragraph}>
                Minha história com programação se iniciou quando comecei a trabalhar em uma empresa que desenvolvia ERP, ali percebi que a área de TI era extensa e tinha diversas oportunidades. Mas eu tinha que fazer uma escolha, qual linguagem de programação estudar? Escolhi o JAVA, pois naquele época eu adorava e adoro LINUX. Como o JAVA era multiplataforma, eu não iria escolher o .NET kkk. Nesta época eu estava com aproximadamente 18 anos, no ano de 2005.
            </p>
            <p className={styles.paragraph}>
                No mesmo ano de 2005, iniciei minha graduação em Ciência da Computação na Faculdade Sumaré em SP. Nesta época eu já tinha uma noção de programação, mas em ShellScript, pois utilizava muito para automazar processos nos servidores LINUX que estavam sob minha gestão. Com LINUX trabalhei em empresas do ramo de Software, Provedores, Laboratórios, Varejista e Hospitalar.
            </p>
            <p className={styles.paragraph}>
                Minha transição para a área de desenvolvimento aconteceu em 2006, quando fui trabalhar em uma empresa que atuava como backoffice para Planos de Saúde. Após esta primeira experiência tive diversas outras atuações na área de tecnologia passando por papéis como: 
                <br/>* Desenvolvedor 
                <br/>* DevOps 
                <br/>* Líder Técnico 
                <br/>* Arquiteto 
                <br/>* Processos
            </p>
            <p className={styles.paragraph}>
                Para suportar minha carreira profissional sempre estudei, seja através de livros, cursos em plataformas digitais e acadêmicos. Nesta jornada fiz alguns cursos de MBA como: 
                <br/>* MBA Engenharia de Software Orientada para Serviços - FIAP (2010 - 2011);
                <br/>* MBA em Gestão Business Process - FGV (2019 - 2022);
                <br/>* MBA Arquitetura de Soluções - PUC Minas (2022 - 2023);
            </p>
            <p className={styles.paragraph}>
                Esta é minha trajetória até aqui e sou grato por ela. Acredito que isto me fez amadurecer muito profissionalmente, atuando em diversas frentes sempre buscando solucionar os problemas das empresas em que atuo. Além de sempre compartilhar o conhecimento adquiro com colegas e profissionais em início de carreira, com conselhos e mentorias.
            </p>
        </PostModel>
    )
}